import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

import Button from '../../Buttons/Button';
import './GuidedTourTooltip.scss';

export const GuidedTourTooltip = ({ continuous, index, step, backProps, closeProps, primaryProps, tooltipProps }) => (
  <div className="guided-tour-tooltip-body" {...tooltipProps}>
    <div className="guided-tour-tooltip-title">
      <CloseIcon className="close-guided-tour" {...closeProps} />
      {step.title}
    </div>
    <div className="guided-tour-tooltip-content">{step.content}</div>
    {step.content2 && <div className="guided-tour-tooltip-content">{step.content2}</div>}
    <div className="guided-tour-tooltip-actions">
      {continuous && <Button {...primaryProps}>{primaryProps.title}</Button>}
      {index > 0 && (
        <Button {...backProps} buttonStyle="secondary" className="back-btn">
          {backProps.title}
        </Button>
      )}
    </div>
  </div>
);

GuidedTourTooltip.defaultProps = {
  continuous: true,
  index: 0,
  step: {},
  closeProps: {},
  primaryProps: {},
  backProps: {}
};

GuidedTourTooltip.propTypes = {
  continuous: PropTypes.bool,
  index: PropTypes.number,
  // TODO: Fix these non-specific prop types
  /* eslint-disable react/forbid-prop-types */
  step: PropTypes.object,
  closeProps: PropTypes.object,
  primaryProps: PropTypes.object,
  backProps: PropTypes.object
  /* eslint-enable react/forbid-prop-types */
};

export default GuidedTourTooltip;
